import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import GameCatalog from "./GameCatalog";

function App() {
  return (
    <div>
      <Navbar />
      {/* Game Catalog */}
      <GameCatalog />

      <Footer />
    </div>
  );
}

export default App;
